import { render, staticRenderFns } from "./ResidentNumberInput.vue?vue&type=template&id=51627659&scoped=true"
import script from "./ResidentNumberInput.vue?vue&type=script&lang=js"
export * from "./ResidentNumberInput.vue?vue&type=script&lang=js"
import style0 from "./ResidentNumberInput.vue?vue&type=style&index=0&id=51627659&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51627659",
  null
  
)

export default component.exports